import ConfirmationDialog from "../shared/ConfirmationDialog";

interface DeletePresentationDialogProps {
  open: boolean;
  presentation: any;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeletePresentationDialog({
  open,
  presentation,
  onConfirm,
  onCancel,
}: DeletePresentationDialogProps) {
  const message = presentation && (
    <>
      Czy na pewno chcesz usunąć prezentację "{presentation.name}
      {presentation.title ? ` - ${presentation.title}` : ""}"?
      <br />
      Tej operacji nie można cofnąć.
    </>
  );

  return (
    <ConfirmationDialog
      open={open}
      title="Potwierdź usunięcie prezentacji"
      message={message}
      confirmText="Usuń"
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmColor="error"
    />
  );
}
